import { AssessmentType } from "../../../api/main/models/codeOnly/AssessmentType";
import { LaunchAssessmentBase } from "../launch/LaunchAssessmentBase";

/**
 * Show results of an assessment session.
 */
export const AssessmentResults = () => (<LaunchAssessmentBase defaultAssessmentType={AssessmentType.Assessment} finishPageOnly={true} />);
